module.exports = __webpack_public_path__ + "images/ds-lda-banner-extend-block.webp";